import { useEffect, useState } from "react";
import { Check, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Stars } from "@/components/Stars";

export default function ReviewsTab() {
  const [status, setStatus] = useState("pending");
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/reviews", { params: { status } }).then((r) => setRows(r.data));
  useEffect(() => {
    let live = true;
    setRows([]);
    api.get("/admin/reviews", { params: { status } }).then((r) => live && setRows(r.data));
    return () => { live = false; };
  }, [status]);

  const act = async (r, approve) => {
    if (!approve && !window.confirm("Delete this review?")) return;
    try {
      if (approve) await api.post(`/admin/reviews/${r.id}/approve`);
      else await api.delete(`/admin/reviews/${r.id}`);
      toast.success(approve ? "Review published" : "Review deleted");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="mt-4" data-testid="reviews-tab">
      <div className="flex gap-2">
        {["pending", "approved"].map((s) => (
          <button key={s} onClick={() => setStatus(s)} className={`rounded-full px-4 py-2 text-sm border ${status === s ? "bg-[#0F172A] text-white" : "bg-white border-[#E2D7C3]"}`} data-testid={`reviews-filter-${s}`}>{s === "pending" ? "Waiting for approval" : "Published"}</button>
        ))}
      </div>
      {rows.length === 0 && <p className="mt-6 text-slate-500" data-testid="reviews-empty">No reviews here.</p>}
      <div className="mt-4 space-y-3">
        {rows.map((r) => (
          <div key={r.id} className="rounded-2xl bg-white border border-[#EDE4D3] p-5 flex gap-4" data-testid={`admin-review-${r.id}`}>
            <div className="flex-1">
              <p className="text-sm font-semibold">{r.product_name}</p>
              <Stars value={r.rating} className="mt-1" />
              <p className="mt-2 text-slate-700">{r.text}</p>
              <p className="mt-2 text-xs text-slate-500">{r.name} · {r.email} · order {r.order_number}</p>
            </div>
            <div className="flex flex-col gap-2">
              {status === "pending" && <button onClick={() => act(r, true)} className="rounded-full bg-[#1B3626] text-white px-4 py-2 text-sm font-semibold flex items-center gap-1" data-testid={`review-approve-${r.id}`}><Check className="w-4 h-4" /> Publish</button>}
              <button onClick={() => act(r, false)} className="rounded-full border border-[#E2D7C3] px-4 py-2 text-sm flex items-center gap-1 hover:text-rose-700" data-testid={`review-delete-${r.id}`}><Trash2 className="w-4 h-4" /> Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
